import { render, staticRenderFns } from "./ParcelPhoto.vue?vue&type=template&id=8cbf0c04&scoped=true&"
import script from "./ParcelPhoto.vue?vue&type=script&lang=js&"
export * from "./ParcelPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ParcelPhoto.vue?vue&type=style&index=0&id=8cbf0c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf0c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VBtn,VIcon,VImg})
